const colours = [
  '#5171ff',
  '#5befff',
  '#00ffc1',
  '#ebff55',
  '#7534ff'
];

export default colours;
